import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { TranslateModule } from "@ngx-translate/core";
import { ApiKeysComponent } from "./api-keys.component";

@NgModule({ declarations: [
        ApiKeysComponent,
    ], imports: [CommonModule,
        TranslateModule], providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())] })
export class TmApiKeysModule{
}